import { render } from "./SondaggioDetail.vue?vue&type=template&id=46879b8b&scoped=true"
import script from "./SondaggioDetail.vue?vue&type=script&lang=js"
export * from "./SondaggioDetail.vue?vue&type=script&lang=js"

import "./SondaggioDetail.vue?vue&type=style&index=0&id=46879b8b&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_seilatv/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46879b8b"]])

export default __exports__